import React, { CSSProperties } from "react";
import styled from "styled-components";

import * as Typography from "~/Typography";

export type Empty = {
  readonly title?: string;
  readonly subtitle?: string;
  readonly style?: CSSProperties;
  readonly svg: { readonly src: string };
};

export const Component: React.Fn<Empty> = ({ title, svg, style, subtitle }) => (
  <Style style={style ?? {}}>
    {title && <Caption.Component>{title}</Caption.Component>}
    <img src={svg.src} />
    {subtitle && <Caption.Component>{subtitle}</Caption.Component>}
  </Style>
);

const Style = styled.div`
  padding: 1em 0;
  text-align: center;

  & > img {
    display: inline-block;
    padding: 2em 0;
    max-height: 23em;
  }
`;

namespace Caption {
  export const Component: Component = ({ children }) => (
    <Typography.H2.Component all>
      <Typography.Component thin muted>
        {children}
      </Typography.Component>
    </Typography.H2.Component>
  );
}
